import ClientsList from "src/components/Clients/List/ClientsList";

const Clients = () => {
  return <ClientsList />;
};

export default Clients;
